import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterLink } from '@angular/router';

import { InformationCardComponent } from '../../../components/information-card/information-card.component';
import { VehicleType } from '../../../services/http/vehicles/vehicles.interface';
import { MunicipalityManagement } from '../../../services/http/municipalities/municipalities.interface';
import { FormsModule } from '@angular/forms';
import { WordpressService } from '../../../services/http/wordpress/wordpress.service';
import { WpClientCode, WpPost, WpPostRequest, WpSectionCode } from '../../../services/http/wordpress/wordpress.interface';
import { ImageSectionHeadComponent } from '../../../components/image-section-head/image-section-head.component';

@Component({
  selector: 'app-autorization-types',
  standalone: true,
  imports: [CommonModule, RouterLink, InformationCardComponent, FormsModule, ImageSectionHeadComponent],
  templateUrl: './autorization-types.component.html',
  styleUrl: './autorization-types.component.scss'
})
export class AutorizationTypesComponent {
  title = "";
  description = "";
  image = "assets/images/Autoritzacions.jpg";

  buttonText = $localize`:@@Autorizations.Button.More:MÁS INFORMACION`;
  cards: VehicleType[] = [];
  municipalities: MunicipalityManagement[] = [];
  municipalitySelectedName = 'Leida';
  itemsToShow = 6
  wpData: WpPost | undefined;

  constructor(
    private readonly wordpressService: WordpressService,
    private readonly router: Router
  ) {
      this.wordpressService.getPost({client: WpClientCode.genCat, section: WpSectionCode.autorizations} as WpPostRequest).subscribe((data) => {
        this.wpData = data;
        this.title = data?.title.rendered || "";
      });
      this.wordpressService.getPosts({client: WpClientCode.genCat, section: WpSectionCode.autorizationType} as WpPostRequest).subscribe((response) => {
        this.cards = response?.sort((a, b) => a.id - b.id)
        .map((label) => {
          return {
            code: label.acf.aluvisa_id,
            name: label.title.rendered,
            description: label.acf.resumen,
            icon: label.acf.icono
          } as VehicleType;
        
        }) || [];
      });
  }

  ngOnInit() {
  }

  showMore() {
    // this.itemsToShow += 3;
    this.itemsToShow = this.cards.length;
  }

  goTo(code: string | undefined) {
    if (!code) return;
    this.router.navigate(['autorizations', code]);
  }
}
